<template>
  <div id="container">
    <div class="item-box-content box-content-title">
      <div class="title-font-style">
        <span>库存汇总表</span>
      </div>
    </div>
    <div>
      <el-form class="search-style" :model="queryParams" label-position="left">
        <el-row :gutter="20">
          <el-col :span="6">
            <el-form-item label="月份：" label-width="45px">
              <el-date-picker
                v-model="time"
                type="month"
                value-format="yyyy-MM"
                placeholder="选择月份"
                style="width:100%"
                 :clearable='false'
              ></el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="仓库：" label-width="45px">
              <el-select v-model="valList[0].value" placeholder="请选择">
                <el-option
                  v-for="(item,index) in stockSelect"
                  :key="index"
                  :label="item.storageName"
                  :value="item.storageName"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="品牌：" label-width="45px">
              <el-select v-model="arr" multiple placeholder="请选择" @change="changeBrand">
                <el-option
                  v-for="(item,index) in brandList"
                  :key="index"
                  :label="item.label"
                  :value="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6" style="margin-bottom:15px;">
            <el-form-item label="系列：" label-width="45px">
              <el-select v-model="name" multiple placeholder="请选择">
                <el-option
                  v-for="(item,index) in seriesList"
                  :key="index"
                  :label="item.label"
                  :value="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="6">
            <el-form-item label="产品名称：" label-width="70px">
              <el-input v-model="valList[3].value"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="型号：" label-width="45px">
              <el-input v-model="valList[4].value"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="订货号：" label-width="60px">
              <el-input v-model="valList[5].value"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-col :span="18" style="padding:0px">
              <el-button type="primary" @click="onSearch">搜索</el-button>
              <el-button @click="onReset">重置</el-button>
            </el-col>
            <el-col :span="6" style="text-align:right;padding:0px;">
              <el-button @click="exportOut">导出</el-button>
            </el-col>
          </el-col>
        </el-row>
      </el-form>
      <div class="box-table" :style="{height:tableHeight+'px'}">
        <el-table
          :summary-method="getSummaries"
          show-summary
          :cell-style="{ textAlign: 'left' }"
          :max-height="tableHeight"
          border
          ref="tableRef"
          tooltip-effect="dark"
          :data="list"
          :header-cell-style="tableHeader"
          v-loading="loadingTable"
          element-loading-text="拼命加载中请稍后..."
          element-loading-spinner="el-icon-loading"
        >
          <el-table-column>
            <el-table-column label="仓库" show-overflow-tooltip>
              <template slot-scope="scope">
                <div class="line-limit-length">{{ scope.row.storageName || '--'}}</div>
              </template>
            </el-table-column>
            <el-table-column label="品牌" show-overflow-tooltip>
              <template slot-scope="scope">
                <div class="line-limit-length">{{ scope.row.brandName || '--'}}</div>
              </template>
            </el-table-column>
            <el-table-column label="系列" show-overflow-tooltip>
              <template slot-scope="scope">
                <div class="line-limit-length">{{scope.row.seriesName || '--'}}</div>
              </template>
            </el-table-column>
            <el-table-column label="产品名称" show-overflow-tooltip>
              <template slot-scope="scope">
                <div class="line-limit-length">{{scope.row.proName || '--'}}</div>
              </template>
            </el-table-column>
            <el-table-column label="型号" show-overflow-tooltip>
              <template slot-scope="scope">
                <div class="line-limit-length">{{scope.row.proModel || '--'}}</div>
              </template>
            </el-table-column>
            <el-table-column label="订货号" show-overflow-tooltip>
              <template slot-scope="scope">
                <div class="line-limit-length">{{scope.row.proOrdernum || '--'}}</div>
              </template>
            </el-table-column>
          </el-table-column>
          <el-table-column label="期初结余">
            <el-table-column label="数量">
              <template slot-scope="scope">
                <div>{{String(scope.row.firstSurplusCount) || '--'}}</div>
              </template>
            </el-table-column>
            <el-table-column label="金额" show-overflow-tooltip>
              <template slot-scope="scope">
                <div class="line-limit-length">{{scope.row.firstSurplusMoney |priceFilterNum}}</div>
              </template>
            </el-table-column>
          </el-table-column>
          <el-table-column label="本期入库">
            <el-table-column label="数量">
              <template slot-scope="scope">
                <div>{{String(scope.row.currentInCount) || '--'}}</div>
              </template>
            </el-table-column>
            <el-table-column label="金额" show-overflow-tooltip>
              <template slot-scope="scope">
                <div class="line-limit-length">{{scope.row.currentInMoney |priceFilterNum}}</div>
              </template>
            </el-table-column>
          </el-table-column>
          <el-table-column label="本期出库" width="100px">
            <el-table-column label="数量">
              <template slot-scope="scope">
                <div>{{String(scope.row.currentOutCount) || '--'}}</div>
              </template>
            </el-table-column>
            <el-table-column label="金额" show-overflow-tooltip>
              <template slot-scope="scope">
                <div class="line-limit-length">{{scope.row.currentOutMoney |priceFilterNum}}</div>
              </template>
            </el-table-column>
          </el-table-column>
          <el-table-column label="期末结余" width="100px">
            <el-table-column label="数量" style="color:#4E555B">
              <template slot-scope="scope">
                <div>{{String(scope.row.lastSurplusCount) || '--'}}</div>
              </template>
            </el-table-column>
            <el-table-column label="金额" show-overflow-tooltip>
              <template slot-scope="scope">
                <div class="line-limit-length">{{scope.row.lastSurplusMoney |priceFilterNum}}</div>
              </template>
            </el-table-column>
          </el-table-column>
        </el-table>
      </div>
      <div class="pagination">
        <pagination
          :total="total"
          :currentPage="currentPage"
          :pageSize="pageSize"
          @handleCurrentChange="handleCurrentChange"
          @handleSizeChange="handleSizeChange"
        ></pagination>
      </div>
    </div>
  </div>
</template>
<script>
import pagination from '@/components/pagination'
import { isSuccess, downLoadFileBlob } from '@/util/tool'
import { getComAll } from '@/api/fiance/fianceManage' // 部门
import { querySeriesByMultiBrandId } from '@/api/storage/storage'
import {
  queryReportStorageCollect,
  exportReportStorageList
} from '@/api/data/data'

export default {
  components: {
    pagination
  },
  mounted() {
    this.gethouseList() // 获取仓库
    this.getBrand() // 获取品牌
    getComAll().then(res => {
      // 部门
      if (isSuccess(res)) {
        this.department =
          res.data.obj && res.data.obj.filter(item => item.orgFatherId !== 0)
      }
    })
    this.addDate()
  },
  data() {
    return {
      arr: [],
      name: [],
      queryParams: {},
      stockSelect: [], // 仓库
      tableHeight: window.innerHeight - 430,
      searchList: [],
      list: [],
      brandList: [], // 品牌列表
      seriesList: [], // 系列列表
      loadingTable: false, // 列表loading
      pageSize: 30, //
      currentPage: 1, // 页码
      total: 0, // 列表总数
      valList: [
        { value: '', column: 'storageName' },
        { value: '', column: 'brandIds' },
        { value: '', column: 'seriesIds' },
        { value: '', column: 'proName' },
        { value: '', column: 'proModel' },
        { value: '', column: 'proOrdernum' }
      ],
      updateTime: '',
      time: ''
    }
  },

  methods: {
    // 获取当前年月
    addDate() {
      const dateObj = new Date()
      const date = {
        year: dateObj.getFullYear()
      }
      const newmonth =
        dateObj.getMonth() + 1 < 10
          ? '0' + (dateObj.getMonth() + 1)
          : dateObj.getMonth() + 1
      this.updateTime = date.year + '-' + newmonth // 本月上个月
      this.time = this.updateTime
      this.onSearch()
    },
    // 总计
    getSummaries(param) {
      // 合计
      const sums = []
      param.columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = '总计'
        } else if (index === 6) {
          sums[index] = param.data.reduce((tot, prov) => {
            return tot + +prov.firstSurplusCount
          }, 0)
        } else if (index === 7) {
          const total = param.data.reduce((tot, prov) => {
            return tot + +prov.firstSurplusMoney
          }, 0)
          sums[index] = total.toFixed(2)
        } else if (index === 8) {
          sums[index] = param.data.reduce((tot, prov) => {
            return tot + +prov.currentInCount
          }, 0)
        } else if (index === 9) {
          const total = param.data.reduce((tot, prov) => {
            return tot + +prov.currentInMoney
          }, 0)
          sums[index] = total.toFixed(2)
        } else if (index === 10) {
          sums[index] = param.data.reduce((tot, prov) => {
            return tot + +prov.currentOutCount
          }, 0)
        } else if (index === 11) {
          const total = param.data.reduce((tot, prov) => {
            return tot + +prov.currentOutMoney
          }, 0)
          sums[index] = total.toFixed(2)
        } else if (index === 12) {
          sums[index] = param.data.reduce((tot, prov) => {
            return tot + +prov.lastSurplusCount
          }, 0)
        } else if (index === 13) {
          const total = param.data.reduce((tot, prov) => {
            return tot + +prov.lastSurplusMoney
          }, 0)
          sums[index] = total.toFixed(2)
        } else {
          sums[index] = ''
        }
      })
      return sums
    },
    // 获取仓库信息
    async gethouseList() {
      this.stockSelect = await this.$houseInformation()
    },
    // 获取品牌
    async getBrand() {
      this.brandList = await this.$queryAllBrandForSelect()
    },
    // 系列加载 根据品牌id加载 系列seriesList
    getSupplierList(ids) {
      querySeriesByMultiBrandId(this.currentPage, this.pageSize, ids)
        .then(res => {
          if (res.data.code === 200) {
            this.seriesList = res.data.obj.records
          } else {
            this.$message.error(res.data.msg)
          }
        })
        .catch(err => {
          console.log(err)
        })
    },
    changeBrand(val) {
      const strl = val.join(',')
      if (val) {
        this.getSupplierList(strl)
      }
    },

    getList() {
      this.loadingTable = true
      const params = {
        criteriaVoList: this.searchList ? this.searchList : [],
        queryPageName: ''
      }
      queryReportStorageCollect(this.currentPage, this.pageSize, params).then(
        res => {
          if (res.data.code === 200) {
            this.list = res.data.obj.records
            this.total = res.data.obj.total
            this.loadingTable = false
          }
        }
      )
    },
    // 查询
    onSearch() {
      this.searchList = []
      this.searchList.push({
        value: this.time,
        column: 'purchaseMonth'
      })
      this.valList[1].value = this.arr.join(',')
      this.valList[2].value = this.name.join(',')
      if (this.valList.some(ele => ele.value) || this.time !== '') {
        this.pageSize = 30
        this.currentPage = 1
        this.valList.forEach(ele => {
          if (ele.value) {
            ele.collection = true
            this.searchList.push(ele)
          }
        })
        this.getList()
      } else {
        this.$message.error('搜索条件不能为空')
      }
    },
    // 重置
    onReset() {
      this.pageSize = 30
      this.currentPage = 1
      this.valList.forEach(ele => {
        delete ele.value
      })
      this.time = ''
      this.arr = []
      this.name = []
      this.seriesList = []
      this.searchList = []
      this.getList()
    },
    // 导出
    exportOut() {
      const params = {
        criteriaVoList: this.searchList,
        queryPageName: ''
      }
      exportReportStorageList(params)
        .then(res => {
          downLoadFileBlob(this, res)
        })
        .catch(err => {
          console.log(err)
        })
    },
    // 设置头部背景色
    tableHeader({ rowIndex }) {
      return this.$tableHeader(rowIndex)
    },
    // 页数
    handleSizeChange(val) {
      this.pageSize = val
      this.currentPage = 1
      this.getList()
    },
    // 页码
    handleCurrentChange(val) {
      this.currentPage = val
      this.getList()
    }
  }
}
</script>
<style lang="less" scoped>
/deep/ .el-table th > .cell {
  font-weight: 500;
  color: #4e555b;
  text-align: left;
}
</style>
